import "./SettingsForm.css";
import { Col, Form, Image } from "react-bootstrap";
import convertToBlob from "../../utilities/convertToBlob";

export default function SettingsImageForm(props) {
  // Image form for the admin's settings page 
  // allows the user to add or delete images, provides a preview of selected images
  return (
    <>
      <Form.Group className="mb-3" controlId={props?.name}>
        <Form.Label>
          <b>{props?.heading}</b>
        </Form.Label>
        <Form.Control
          name={props?.name}
          type="file"
          accept="image/*"
          // disabled={imageIsLoading}
          onChange={async (event) => {
            const newImage = event.target.files[0];
            if (
              !props?.newImage &&
              props.settingsData?.[props.name]?.public_id
            ) {
              props.setDeletedImagesPublicIds([
                ...props.deletedImagesPublicIds,
                props.settingsData?.[props.name]?.public_id,
              ]);
            }
            props.setNewImage(newImage);
            props.handleChange(event); //formik's
            event.target.value = null; // Clear input manually, else onChange won't run if choose same image again
          }}
        />
      </Form.Group>
 {/* ...show currently chosen image */}
      {props.values?.[props?.name] && (
        <Col>
          <div style={{ position: "relative" }} className="my-3">
            {props?.newImage ? (
              <Image
                className={`${props?.name === "logo" ? "settings-preview-logo" : "settings-preview-file"}`}
                src={URL.createObjectURL(convertToBlob([props.newImage])[0])}
              ></Image>
            ) : (
              props.settingsData?.[props?.name] &&
              props.settingsData?.[props?.name]?.public_id && (
                <Image
               className={`${props?.name === "logo" ? "settings-preview-logo" : "settings-preview-file"}`}
                  src={props.settingsData?.[props?.name]?.url}
                ></Image>
              )
            )}
            <i
              className="bi bi-x-circle media-x-button"
              onClick={() => {
                if (props.newImage) {
                  props.setNewImage(null);
                } else {
                  props.setDeletedImagesPublicIds([
                    ...props.deletedImagesPublicIds,
                    props.settingsData?.[props?.name]?.public_id,
                  ]);
                  props.setDeletedFiles({
                    ...props.deletedFiles,
                    [props.name]: true,
                  });
                }
                props.handleChange({
                  target: {
                    name: props.name,
                    value: "",
                  },
                });
              }}
            ></i>
          </div>
        </Col>
      )}
    </>
  );
}
